export const styleVueCreator = (colors, styles) => {
  /*

    colors = {
        primary : "",
        secondary : "",
        tertiary : ""
    }

    styles = {
        backgrond : 'primary',
        color: 'tertiary'
    }
    */

  let stylesObject = {};
  for (const property in styles) {
    if (styles.hasOwnProperty(property)) {
      const color = styles[property];
      stylesObject[property] = colors[color];
    }
  }
  return stylesObject;
};
